module.exports = __webpack_public_path__ + "img/arc.2f3c7d50.png";